import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { PlantationDetailsPartThreeTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import { FrequencyforFertilizerDDL } from "../../../../CommonDDL/FrequencyforFertilizerDDL";
import { WeedManagementPracticesDDL } from "../../../../CommonDDL/WeedManagementPracticesDDL";
import { FertilizerPostAPI, GrowthDwarfismPostAPI, PlantationDetailsPartFivePatchAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFiveSlice";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import OtherInsertSection from "../OtherInsertSection";
import { FertilizerTable } from "./FertilizerTable";
import { CommonCircle } from "../CommonCircle";
import { PlantsGrowthTable } from "./PlantsGrowthTable";

const PartFivePopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal, Title,YearValue,MonthValue } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails


    const [RadioDiseasesObserved, setRadioDiseasesObserved] = useState('')
    const [RadioAddFertilizers, setRadioAddFertilizers] = useState('')
    const [RadioDwarfism, setRadioDwarfism] = useState('')
    const [RadioLabourPlantation, setRadioLabourPlantation] = useState('')

    const [PlantationTechniquesPopup, setPlantationTechniquesPopup] = useState(false)
    const [PlantationDetailsPartFive, setPlantationDetailsPartFive] = useState([])

    const [NameofFertilizer, setNameofFertilizer] = useState('')
    const [PlantsGrowth, setPlantsGrowth] = useState('')
    const [TimeTakenPlantation, setTimeTakenPlantation] = useState('')
    const [DailyLabourCharges, setDailyLabourCharges] = useState('')
    const [IsOthersData, setIsOthersData] = useState(false)
    const [IsFertilizerData, setIsFertilizerData] = useState(false)
    const [IsGrowthData, setIsGrowthData] = useState(false)


    const [FrequencyFertilizerId, setFrequencyFertilizerId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WeedManagementPracticesId, setWeedManagementPracticesId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            T_BeneficiaryPlantationDetailsID: 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationPart5",
            token: token,
            setPlantationDetailsPartFive: setPlantationDetailsPartFive,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

        }

    }, [IsFertilizerData,IsGrowthData,YearValue, MonthValue])


    const { isLoading } = useSelector(state => state.PlantationDetailsPartThreeTableData)

    useEffect(() => {
        setRadioAddFertilizers(PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.anyFertilizers_M_IndicatorID)
        setNameofFertilizer(flag == 'Update' ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.whichFertilizer : '')
        setRadioDiseasesObserved(PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.diseasesObserved_M_IndicatorID)
        setRadioDwarfism(PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.observedDwarfism_M_IndicatorID)
        setPlantsGrowth(flag == 'Update' ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.plantsGrowth : '')
        setRadioLabourPlantation(PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.labour_For_Plantation_M_IndicatorID)
        setTimeTakenPlantation(flag == 'Update' ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.timeForPlantation : '')
        setDailyLabourCharges(flag == 'Update' ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.dailyLabourCharges : '')

    }, [PlantationDetailsPartFive])

    const handleUpdate = () => {

        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            T_BeneficiaryPlantationDetailsID: 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            AnyFertilizers_M_IndicatorID: RadioAddFertilizers,
            WeedPractices_M_IndicatorID: WeedManagementPracticesId.ID,
            DiseasesObserved_M_IndicatorID: RadioDiseasesObserved,
            ObservedDwarfism_M_IndicatorID: RadioDwarfism,
            Labour_For_Plantation_M_IndicatorID: RadioLabourPlantation,
            TimeForPlantation: TimeTakenPlantation,
            DailyLabourCharges: DailyLabourCharges,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost

        }
        dispatch(PlantationDetailsPartFivePatchAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantationDetailsPartFivePatchData)


    // ------------------Fertilizer Post API--------------------------

    const handleFertilizerUpdateData = () => {
        const data = {
            T_BeneficiaryPlantationDetailsID: PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID : 0,
            WhichFertilizer: NameofFertilizer,
            Frequency_For_Fertilizer_M_IndicatorID: FrequencyFertilizerId.ID,
            M_TableUserMasterID: UserID,
            token: token,

            // handleIsFenchData: handleIsFenchData
        }
        dispatch(FertilizerPostAPI({ data }))
    }

    const { isPostLoading2 } = useSelector(state => state.FertilizerPostData)

    // ------------------Growth Post API--------------------------

    const handleGrowthUpdateData = () => {
        const data = {
            T_BeneficiaryPlantationDetailsID: PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID : 0,
            PlantsGrowth: PlantsGrowth,
            M_TableUserMasterID: UserID,
            token: token,

            // handleIsFenchData: handleIsFenchData
        }
        dispatch(GrowthDwarfismPostAPI({ data }))
    }

    const { isPostLoading3 } = useSelector(state => state.FertilizerPostData)

    
    return (
        <>
            {isLoading ? <Loading /> :
                <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                    <div className="modal-dialog modal-lg " style={{ minWidth: '40vw' }} role="document"  >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                                <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'scroll', height: '80vh' }}>

                                <div className="row">
                                    <div className="col-12 col-lg-10 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Do you add any Fertilizer :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioAddFertilizers('53')} id='53' name={RadioAddFertilizers == 53} value="53" checked={RadioAddFertilizers == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioAddFertilizers('54')} id='54' name={RadioAddFertilizers == 54} value="54" checked={RadioAddFertilizers == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {

                                            RadioAddFertilizers == "53" ?
                                                <span>
                                                    <div className="col-12 col-lg-6 pt-3">
                                                        <span className="">Name of Fertilizer : </span>
                                                        <input
                                                            type="text"
                                                            className="form-control mt-2 "
                                                            name="NameofFertilizer"
                                                            placeholder="type..."
                                                            value={NameofFertilizer}
                                                            onChange={(e) => setNameofFertilizer(e.target.value)}

                                                        />
                                                    </div>


                                                    <div className="col-12 col-lg-8 pt-3">
                                                        <div className="row">
                                                            <div className="col-lg-8">
                                                                <FrequencyforFertilizerDDL
                                                                    FrequencyFertilizerId={FrequencyFertilizerId}
                                                                    setFrequencyFertilizerId={setFrequencyFertilizerId}
                                                                    apiFlag='Fertilizer'
                                                                    Flag={flag}
                                                                    data={PlantationDetailsPartFive && PlantationDetailsPartFive[0]}
                                                                    IsPost={IsOthersData}
                                                                />
                                                            </div>

                                                            <div className="col-4 col-lg-3 mb-3 pt-lg-3  mt-lg-3">

                                                                <span className=" cursor-pointer text-white update_button" id="basic-addon2" style={{ background: "#dc3545" }}
                                                                    onClick={handleFertilizerUpdateData}
                                                                >
                                                                    Update</span>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    {
                                                        FrequencyFertilizerId.ID == 4 &&
                                                        <OtherInsertSection
                                                            Flag='Fertilizer'
                                                            IsOthersData={IsOthersData}
                                                            setIsOthersData={setIsOthersData}

                                                        />

                                                    }

                                                    <FertilizerTable
                                                        isLoading={isLoading}
                                                        PlantationDetailsPartFive={PlantationDetailsPartFive}
                                                        setPlantationDetailsPartFive={setPlantationDetailsPartFive}
                                                        T_BeneficiaryPlantationDetailsID={PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                        IsFertilizerData={IsFertilizerData}
                                                        setIsFertilizerData={setIsFertilizerData}
                                                        setNameofFertilizer={setNameofFertilizer}
                                                        FrequencyFertilizerId={FrequencyFertilizerId}
                                                        setFrequencyFertilizerId={setFrequencyFertilizerId}
                                                    />

                                                </span>
                                                :
                                                ''
                                        }
                                    </div>

                                    <div className="col-12 col-lg-10 pt-3 pb-3 mx-auto border-bottom">
                                        <WeedManagementPracticesDDL
                                            WeedManagementPracticesId={WeedManagementPracticesId}
                                            setWeedManagementPracticesId={setWeedManagementPracticesId}
                                            apiFlag='WeedManagement'
                                            Flag={flag}
                                            data={PlantationDetailsPartFive && PlantationDetailsPartFive[0]}
                                            IsPost={IsOthersData}
                                        />
                                        {
                                            WeedManagementPracticesId.ID == 5 &&
                                            <OtherInsertSection
                                                Flag='Weed'
                                                IsOthersData={IsOthersData}
                                                setIsOthersData={setIsOthersData}

                                            />
                                        }

                                    </div>


                                    <div className="col-12 col-lg-10 mx-auto pt-3">
                                        <CommonCircle />
                                        <span className="">
                                            Pests or diseases observed ? :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioDiseasesObserved('53')} id='53' name={RadioDiseasesObserved == 53} value="53" checked={RadioDiseasesObserved == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioDiseasesObserved('54')} id='54' name={RadioDiseasesObserved == 54} value="54" checked={RadioDiseasesObserved == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                    </div>

                                    <div className="col-12 col-lg-10 pt-3 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Observed stunned growth or dwarfism  :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioDwarfism('53')} id='53' name={RadioDwarfism == 53} value="53" checked={RadioDwarfism == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioDwarfism('54')} id='54' name={RadioDwarfism == 54} value="54" checked={RadioDwarfism == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {

                                            RadioDwarfism == "53" ?
                                                <>


                                                    <div className=" col-12 col-lg-8 pb-3">

                                                        <div className="row">
                                                            <div className="col-8">
                                                                <div className="py-1">
                                                                    Plants Growth  :
                                                                </div>
                                                                <div class="input-group mb-3 ">

                                                                    <input
                                                                        type="text"
                                                                        className="form-control mt-2 "
                                                                        name="PlantsGrowth"
                                                                        placeholder="type..."
                                                                        value={PlantsGrowth}
                                                                        onChange={(e) => setPlantsGrowth(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-3 pt-4 mt-4">
                                                                <span className=" cursor-pointer text-white update_button" id="basic-addon2" style={{ background: "#dc3545" }}
                                                                onClick={handleGrowthUpdateData}
                                                                >
                                                                    Update</span>
                                                            </div>

                                                            <PlantsGrowthTable
                                                                isLoading={isLoading}
                                                                PlantationDetailsPartFive={PlantationDetailsPartFive}
                                                                setPlantationDetailsPartFive={setPlantationDetailsPartFive}
                                                                T_BeneficiaryPlantationDetailsID={PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPartFive && PlantationDetailsPartFive[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                                                M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                                IsGrowthData={IsGrowthData}
                                                                setIsGrowthData={setIsGrowthData}
                                                                setPlantsGrowth={setPlantsGrowth}
                                                               
                                                            />



                                                        </div>

                                                    </div>

                                                </>

                                                :
                                                ''
                                        }
                                    </div>


                                    <div className="col-12 col-lg-10 pt-3 pb-2 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Labour used for plantation :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioLabourPlantation('53')} id='53' name={RadioLabourPlantation == 53} value="53" checked={RadioLabourPlantation == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioLabourPlantation('54')} id='54' name={RadioLabourPlantation == 54} value="54" checked={RadioLabourPlantation == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>
                                    </div>

                                </div>

                                <div className="col-12 col-lg-10 mx-auto pt-3 pb-3 border-bottom">
                                    <CommonCircle />
                                    <span className="">Time taken for Plantation (days)  : </span>
                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control mt-2 "
                                                name="TimeTakenPlantation"
                                                placeholder="value"
                                                value={TimeTakenPlantation}
                                                onChange={(e) => setTimeTakenPlantation(e.target.value)}

                                            />
                                        </div>
                                    </div>

                                </div>


                                <div className="col-12 col-lg-10 mx-auto pt-3 pb-3 border-bottom">
                                    <CommonCircle />
                                    <span className="">Daily labour charges (Rs)  : </span>
                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            <input
                                                type="text"
                                                className="form-control mt-2 "
                                                name="DailyLabourCharges"
                                                placeholder="value"
                                                value={DailyLabourCharges}
                                                onChange={(e) => setDailyLabourCharges(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                </div>

                                <div className="col-12 pt-5 ">
                                    <div className="form-group w-80 d-flex justify-content-center">
                                        <button
                                            type='button'
                                            onClick={() => handleUpdate()}
                                            className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => handleShowAddModal(false, '')}
                                            className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                            Cancel
                                        </button>
                                    </div>
                                </div>




                            </div>
                        </div>

                    </div>
                </div >
            }

        </>);
}

export default PartFivePopup;